import React from 'react';

import { GenericSpan, GenericP } from 'commonStyles';

const BookingIdCell = ({ title, bookingId }) => {
	if (!title) {
		return <GenericSpan>{bookingId}</GenericSpan>;
	}

	return (
		<GenericSpan>
			<GenericP fsize='14px' $lHeight='20px' f_weight='900' color='#000'>{title}</GenericP>
			{bookingId && (
				<GenericP fsize='12px' $lHeight='16px' color='#4a4a4a'>{bookingId}</GenericP>
			)}
		</GenericSpan>
	);
};

export default BookingIdCell;
